import React from 'react';
import { Button, Icon } from '@weezevent/nacre';
import css from './modal-popup.module.css';
import ModalItem from '../ManualModal/ModalZone/ModalItem';
import { useTranslation } from 'react-i18next';
export default function ModalZone({
    zone,
    setPopUp,
    setShowSeats = () => {},
    onBackToRoot,
    availability,
    inventories,
    currentInventory,
    currency,
    rates,
    isBooking,
    selectedRates,
    onSelectRate,
    onAddAttendee = () => {}
}) {
    const { t } = useTranslation();
    const [pickerInfo, SetPickerInfo] = React.useState([]);

    const handleClose = React.useCallback(() => {
        onBackToRoot();
    }, [onBackToRoot]);

    const handleSeats = React.useCallback(() => {
        if (availability.seats.length) {
            setShowSeats(true);
            setPopUp(false);
        }
    }, [availability]);

    const onPickerChange = React.useCallback(
        (rate_id, quantity) => {
            // We have to get if a quantity has been picked in childs to enabled the save button

            let pickerInfoTmp = [...pickerInfo];
            let pickerInformationIndex = pickerInfoTmp.findIndex(info => info.rate_id === rate_id);
            if (pickerInformationIndex >= 0) {
                pickerInfoTmp[pickerInformationIndex].quantity = quantity;
            } else {
                pickerInfoTmp.push({ rate_id: rate_id, quantity: quantity });
            }
            SetPickerInfo(pickerInfoTmp);
        },
        [pickerInfo, SetPickerInfo]
    );

    return (
        <div className={css['modal-popup-container']}>
            <div className={css['modal-popup']} zone-info>
                <div className={css['modal-popup-header']}>
                    <div className={css['modal-popup-header-title']}>{zone?.name}</div>
                    <Icon className={css['modal-popup-header-toggle']} name="cross" onClick={isBooking ? null : handleClose} size="regular" />
                </div>
                <div className={css['modal-popup-body']}>
                    <Button
                        basic={false}
                        fluid
                        style={{ backgroundColor: zone?.categories[0]?.color }}
                        inverted={false}
                        onClick={handleSeats}
                        label={
                            <div className={css['modal-zone-label']}>
                                <span>{zone?.name}</span>
                                {availability.seats.length > 0 && (
                                    <div className={css['modal-zone-chevron']}>
                                        {t('attendees.addAttendees.withSeats.popup.seats')}
                                        <div>
                                            <Icon circular={false} color={'white'} inverted={false} margin name="chevron-right" onClick={null} size="regular" />
                                        </div>
                                    </div>
                                )}
                            </div>
                        }
                    />
                    {zone.categories.map(category => (
                        <ModalItem
                            key={category.id}
                            category={category}
                            currency={currency}
                            rates={rates}
                            inventories={inventories}
                            selectedRates={selectedRates}
                            onSelectRate={onSelectRate}
                            onPickerChange={onPickerChange}
                            currentInventory={currentInventory}
                        />
                    ))}

                    <Button
                        fluid
                        primary
                        disabled={!pickerInfo.some(picker => picker.quantity > 0) || isBooking}
                        onClick={() => onAddAttendee(true)}
                        label={t(`ticket.common.action.add`)}
                    />
                </div>
            </div>
        </div>
    );
}
